import { render } from "./VisitDetails.vue?vue&type=template&id=c50fe9d8"
import script from "./VisitDetails.vue?vue&type=script&lang=js"
export * from "./VisitDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__